import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { useReducer, useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { getRelativeDateLocalization } from './../../../../helpers/localization/localizationUtils';

dayjs.extend(isSameOrBefore);

const mapFlightTypeValue = {
  ROUND_TRIP: 'rt',
  ONE_WAY: 'ow'
};

const ONE_WAY = 'ONE_WAY';
const ROUND_TRIP = 'ROUND_TRIP';
const EMPTY_FROM_API = 'EMPTY_FROM_API';
const CASH = 'CASH';
const POINTS = 'POINTS';
const DEPARTURE_DATE = 'DEPARTURE_DATE';
const RETURN_DATE = 'RETURN_DATE';

function updateAvailableAtomsBody(atoms, element) {
  let newArray = atoms.filter((item) => item !== 'FareItemMiles' && item !== 'FareItemPrice');
  newArray.push(element);
  return newArray;
}

function updateExperimentelAtoms(atoms, element) {
  return atoms.map((item) =>
    item === 'FareItemMiles' || item === 'FareItemPrice' ? element : item
  );
}

function isLastDayOfMonth(date) {
  return dayjs(date).isSame(dayjs(date).endOf('month'), 'day');
}

function getIsDisregarded(
  day,
  currentMonth,
  departureFare,
  fare,
  flightTypeValue,
  isReturnDateSelected
) {
  if (departureFare && isReturnDateSelected) {
    return false;
  }
  if (flightTypeValue !== ONE_WAY) {
    if (departureFare && dayjs(day).isSame(dayjs(departureFare.day), 'day')) {
      return false;
    } else if (fare && dayjs(day).isSame(dayjs(fare.day), 'day')) {
      return false;
    }
  }
  return (
    dayjs(dayjs(day).format('MM/DD/YYYY')).isBefore(
      dayjs(dayjs(currentMonth).format('MM/DD/YYYY'))
    ) &&
    (dayjs(dayjs(day).format('MM/DD/YYYY')).isAfter(dayjs(dayjs().format('MM/DD/YYYY'))) ||
      dayjs(dayjs(day).format('MM/DD/YYYY')).isSame(dayjs(dayjs().format('MM/DD/YYYY'))))
  );
}

function findFare(data, date) {
  const fare = data.filter(
    (item) => dayjs(date).format('MM/DD/YYYY') === dayjs(item.day).format('MM/DD/YYYY')
  )[0];
  return fare;
}

const calendarReducer = (state, action) => {
  switch (action.type) {
    case 'SET_FIRST_DAY': {
      return { ...state, firstDay: action.payload };
    }
    case 'SET_FOCUS_DATE': {
      return { ...state, focusDate: action.payload };
    }
    case 'SET_AVOID_FOCUS_DATE_ACTION': {
      return { ...state, avoidFocusDateAction: action.payload };
    }
    case 'SET_FARE': {
      return { ...state, fare: action.payload };
    }
    case 'SET_DEPARTURE_FARE': {
      return { ...state, departureFare: action.payload };
    }
    case 'SET_DEPARTURE_DATE': {
      return { ...state, departureDate: action.payload };
    }
    case 'SET_RETURN_DATE': {
      return { ...state, returnDate: action.payload };
    }
    case 'SET_LAST_SELECTED_DATE': {
      return { ...state, lastSelectedDate: action.payload };
    }
    case 'SET_LAST_HOVERED_DATE': {
      return { ...state, lastHoveredDate: action.payload };
    }
    case 'SET_CHANGE_FLIGHT_TYPE_FILTER': {
      if (state.changeFlightTypeFilter === null) {
        return { ...state, changeFlightTypeFilter: undefined };
      } else {
        return { ...state, changeFlightTypeFilter: action.payload };
      }
    }
    case 'SET_CHANGE_TRAVEL_CLASS_FILTER': {
      if (state.changeTravelClassFilter === null) {
        return { ...state, changeTravelClassFilter: undefined };
      } else {
        return { ...state, changeTravelClassFilter: action.payload };
      }
    }
    case 'SET_CHANGE_REDEMPTION_UNIT_FILTER': {
      if (state.changeRedemptionUnitFilter === null) {
        return { ...state, changeRedemptionUnitFilter: undefined };
      } else {
        return { ...state, changeRedemptionUnitFilter: action.payload };
      }
    }
    case 'SET_CHANGE_NUMBER_OF_STOP_FILTER': {
      if (state.changeNumberOfStopFilter === null) {
        return { ...state, changeNumberOfStopFilter: undefined };
      } else {
        return { ...state, changeNumberOfStopFilter: action.payload };
      }
    }
    case 'SET_CHANGE_CURRENT_MONTH': {
      return { ...state, changeCurrentMonth: action.payload };
    }
    case 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE': {
      return { ...state, mobileDepartureDateConfirmed: action.payload };
    }
    case 'SET_CHANGE_CONFIRMED_RETURN_DATE': {
      return { ...state, mobileReturnDateConfirmed: action.payload };
    }
    case 'SET_CHANGE_SELECTED_RETURN_DATE_CONFIRMED': {
      return { ...state, selectedReturnDateUpdated: action.payload };
    }
    case 'SET_WAS_RETURN_DATE_SELECTED': {
      return { ...state, wasReturnDateSelected: action.payload };
    }
    case 'SET_CONFIRMED_CHANGE_DEPARTURE_DATE': {
      return { ...state, confirmedChangeDepartureDate: action.payload };
    }
    case 'SET_SHOW_CALENDAR_EMPTY': {
      return { ...state, showCalendarEmpty: action.payload };
    }
    case 'SET_UPDATE_DEPARTURE_FARE_DATA': {
      return { ...state, updateDepartureFareData: action.payload };
    }
    case 'SET_FLAG_TO_NOT_SHOW_CALENDAR_EMPTY': {
      return { ...state, flagToNotShowCalendarEmpty: action.payload };
    }
    case 'SET_INITIAL_STATE': {
      return {
        firstDay: action.payload,
        focusDate: action.payload,
        avoidFocusDateAction: undefined,
        fare: undefined,
        departureFare: undefined,
        departureDate: undefined,
        returnDate: undefined,
        lastHoveredDate: undefined,
        lastSelectedDate: undefined,
        changeCurrentMonth: false,
        changeFlightTypeFilter: undefined,
        changeTravelClassFilter: undefined,
        changeRedemptionUnitFilter: undefined,
        changeNumberOfStopFilter: undefined,
        mobileDepartureDateConfirmed: undefined,
        mobileReturnDateConfirmed: undefined,
        selectedReturnDateUpdated: undefined,
        wasReturnDateSelected: false,
        confirmedChangeDepartureDate: undefined,
        showCalendarEmpty: false,
        updateDepartureFareData: false,
        flagToNotShowCalendarEmpty: false
      };
    }
    default: {
      return state;
    }
  }
};

function useFlightCalendar({ globalDispatch, combinable, tenantCode }) {
  const { translate, localizationData, moment: ingloriousMomentNeverUseMe } = useContext(Context);
  const relativeTime = getRelativeDateLocalization(translate, localizationData);
  ingloriousMomentNeverUseMe.locale(relativeTime.name, relativeTime);

  const [state, dispatch] = useReducer(calendarReducer, {
    firstDay: dayjs().toDate(),
    focusDate: undefined,
    avoidFocusDateAction: undefined,
    fare: undefined,
    departureFare: undefined,
    departureDate: undefined,
    returnDate: undefined,
    lastHoveredDate: undefined,
    lastSelectedDate: undefined,
    changeCurrentMonth: false,
    changeFlightTypeFilter: null,
    changeTravelClassFilter: null,
    changeRedemptionUnitFilter: null,
    changeNumberOfStopFilter: null,
    mobileDepartureDateConfirmed: undefined,
    mobileReturnDateConfirmed: undefined,
    selectedReturnDateUpdated: undefined,
    wasReturnDateSelected: false,
    showCalendarEmpty: false,
    updateDepartureFareData: false,
    flagToNotShowCalendarEmpty: false
  });

  const trackDepartureDateSelection = (date, dateRange) => {
    let name = 'DATE_RANGE_HISTOGRAM_CHANGE_DEPARTURE_DATE';
    if (!state.departureDate) {
      name = 'DATE_RANGE_HISTOGRAM_SELECT_DEPARTURE_DATE';
    }
    //tracking
    globalDispatch({
      type: name,
      payload: {
        dateRange: {
          ...dateRange,
          start: date,
          action: '-'
        },
        histogramType: ''
      }
    });
  };
  const trackReturnDateSelection = (date, dateRange) => {
    let name = 'DATE_RANGE_HISTOGRAM_CHANGE_RETURN_DATE';
    if (!state.wasReturnDateSelected) {
      name = 'DATE_RANGE_HISTOGRAM_SELECT_RETURN_DATE';
    }
    globalDispatch({
      type: name,
      payload: {
        dateRange: {
          ...dateRange,
          start: date,
          action: '-'
        },
        histogramType: ''
      }
    });
  };

  const updateShowCurrencyCode = (settings, fare, isOneWayTrip) => {
    let newSettings = { ...settings };
    if (!fare) {
      newSettings = {
        ...newSettings,
        fareItemPrice: {
          ...newSettings.fareItemPrice,
          showCurrencyCode: true,
          currencyToDisplay: ''
        },
        fareItemMiles: {
          ...newSettings.fareItemMiles,
          showCurrencyCode: true,
          currencyToDisplay: ''
        }
      };
    } else {
      if (fare?.fareItem?.dataType === 'DATA_API') {
        if (
          combinable &&
          !isOneWayTrip &&
          state?.departureFare?.fareItem?.dataType !== 'DATA_API'
        ) {
          newSettings = {
            ...newSettings,
            fareItemPrice: {
              ...newSettings.fareItemPrice,
              showCurrencyCode: true,
              currencyToDisplay: ''
            },
            fareItemMiles: {
              ...newSettings.fareItemMiles,
              showCurrencyCode: true,
              currencyToDisplay: ''
            }
          };
        } else {
          newSettings = {
            ...newSettings,
            fareItemPrice: {
              ...newSettings.fareItemPrice,
              showCurrencyCode: false,
              currencyToDisplay: ''
            },
            fareItemMiles: {
              ...newSettings.fareItemMiles,
              showCurrencyCode: false,
              currencyToDisplay: ''
            }
          };
        }
      } else {
        newSettings = {
          ...newSettings,
          fareItemPrice: {
            ...newSettings.fareItemPrice,
            showCurrencyCode: true,
            currencyToDisplay: ''
          },
          fareItemMiles: {
            ...newSettings.fareItemMiles,
            showCurrencyCode: false,
            currencyToDisplay: ''
          }
        };
      }
    }
    return newSettings;
  };

  const focusDay = (date) => {
    requestAnimationFrame(() => {
      const btn = document.getElementById(`day-${dayjs(date).format('YYYY-MM-DD')}`);
      if (btn) {
        btn?.focus();
      }
    });
  };

  const handlerDayClick = ({
    date,
    fare,
    isOneWayTrip,
    event,
    dateRange,
    numberOfMonths,
    isMobile
  }) => {
    if (combinable) {
      if (isOneWayTrip) {
        trackDepartureDateSelection(date, dateRange);
        dispatch({ type: 'SET_DEPARTURE_DATE', payload: date });
        let newFare = { ...fare };
        if (newFare?.fareItem?.dataType === EMPTY_FROM_API) {
          newFare.fareItem.flightType = ONE_WAY;
          newFare.fareItem.airlineCode = tenantCode;
        }
        dispatch({ type: 'SET_FARE', payload: newFare });
        globalDispatch({
          type: 'MODIFY_DEPARTURE_DATE_HISTOGRAM',
          payload: {
            departureDate: date
          }
        });
      } else {
        dispatch({ type: 'SET_CONFIRMED_CHANGE_DEPARTURE_DATE', payload: false });
        if (!state.lastSelectedDate) {
          trackDepartureDateSelection(date, dateRange);
          dispatch({ type: 'SET_DEPARTURE_DATE', payload: date });
          dispatch({
            type: 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE',
            payload: { date, status: 'NO_CONFIRMED' }
          });
          dispatch({ type: 'SET_DEPARTURE_FARE', payload: fare });
          dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: DEPARTURE_DATE });
          dispatch({ type: 'SET_FARE', payload: undefined });
          let start = date;
          if (
            isLastDayOfMonth(date) &&
            dayjs(date)
              .add(1, 'day')
              .isBefore(dayjs().startOf('month').add(numberOfMonths, 'month'), 'month')
          ) {
            start = dayjs(date).add(1, 'day').toDate();
          }
          if (isMobile) {
            globalDispatch({
              type: 'DATE_RANGE_HISTOGRAM_CHANGE',
              payload: {
                dateRange: {
                  departureDate: date,
                  start: start,
                  end: dayjs(start).endOf('month').toDate(),
                  action: 'combinable-destination-origin'
                },
                histogramType: 'OUTBOUND'
              }
            });
          } else {
            globalDispatch({
              type: 'DATE_RANGE_HISTOGRAM_CHANGE',
              payload: {
                dateRange: {
                  departureDate: date,
                  start: dayjs(dateRange.value.start).toDate(),
                  end: dayjs(dateRange.value.end).toDate(),
                  action: `combinable-destination-origin`
                },
                histogramType: 'INBOUND'
              }
            });
          }
        } else {
          if (state.lastSelectedDate === DEPARTURE_DATE) {
            trackReturnDateSelection(date, dateRange);
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_RETURN_DATE',
              payload: { date, status: 'CONFIRMED' }
            });
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE',
              payload: { date: state.mobileDepartureDateConfirmed?.date, status: 'CONFIRMED' }
            });
            dispatch({ type: 'SET_RETURN_DATE', payload: date });
            if (!state.wasReturnDateSelected) {
              dispatch({ type: 'SET_WAS_RETURN_DATE_SELECTED', payload: true });
            }
            dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: RETURN_DATE });
            let newFare = { ...fare };
            if (newFare?.fareItem?.dataType === EMPTY_FROM_API) {
              newFare.fareItem.flightType = ONE_WAY;
              newFare.fareItem.airlineCode = tenantCode;
            }
            dispatch({ type: 'SET_FARE', payload: newFare });
            dispatch({ type: 'SET_SHOW_CALENDAR_EMPTY', payload: true });
            globalDispatch({
              type: 'MODIFY_ACTION_HISTOGRAM',
              payload: {
                action: `combinable--${date}`
              }
            });
          } else if (state.lastSelectedDate === RETURN_DATE) {
            dispatch({ type: 'SET_FLAG_TO_NOT_SHOW_CALENDAR_EMPTY', payload: true });
            trackDepartureDateSelection(date, dateRange);
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE',
              payload: { date, status: 'NO_CONFIRMED' }
            });
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_RETURN_DATE',
              payload: { date: undefined, status: 'NO_CONFIRMED' }
            });
            dispatch({ type: 'SET_DEPARTURE_DATE', payload: date });
            dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: DEPARTURE_DATE });

            dispatch({ type: 'SET_FARE', payload: undefined });
            dispatch({ type: 'SET_RETURN_DATE', payload: undefined });
            dispatch({ type: 'SET_LAST_HOVERED_DATE', payload: undefined });
            dispatch({ type: 'SET_DEPARTURE_FARE', payload: fare });
            let start = date;
            if (
              isLastDayOfMonth(date) &&
              dayjs(date)
                .add(1, 'day')
                .isBefore(dayjs().startOf('month').add(numberOfMonths, 'month'), 'month')
            ) {
              start = dayjs(date).add(1, 'day').toDate();
            }
            dispatch({ type: 'SET_UPDATE_DEPARTURE_FARE_DATA', payload: true });
            if (isMobile) {
              globalDispatch({
                type: 'DATE_RANGE_HISTOGRAM_CHANGE',
                payload: {
                  dateRange: {
                    start: start,
                    end: dayjs(start).endOf('month').toDate(),
                    departureDate: date,
                    returnDate: undefined,
                    action: 'combinable-destination-origin-and-departure'
                  },
                  histogramType: 'INBOUND'
                }
              });
            } else {
              globalDispatch({
                type: 'DATE_RANGE_HISTOGRAM_CHANGE',
                payload: {
                  dateRange: {
                    start: dayjs(dateRange.value.start).toDate(),
                    end: dayjs(dateRange.value.end).toDate(),
                    departureDate: date,
                    returnDate: undefined,
                    action: `combinable-destination-origin-and-departure_${DEPARTURE_DATE}`
                  },
                  histogramType: 'INBOUND'
                }
              });
            }
          }
        }
      }
    } else {
      if (isOneWayTrip) {
        trackDepartureDateSelection(date, dateRange);
        dispatch({ type: 'SET_DEPARTURE_DATE', payload: date });
        let newFare = { ...fare };
        if (newFare?.fareItem?.dataType === EMPTY_FROM_API) {
          newFare.fareItem.flightType = ONE_WAY;
          newFare.fareItem.airlineCode = tenantCode;
        }
        dispatch({ type: 'SET_FARE', payload: newFare });
        globalDispatch({
          type: 'MODIFY_DEPARTURE_DATE_HISTOGRAM',
          payload: {
            departureDate: date
          }
        });
      } else {
        dispatch({ type: 'SET_CONFIRMED_CHANGE_DEPARTURE_DATE', payload: false });
        if (!state.lastSelectedDate) {
          trackDepartureDateSelection(date, dateRange);
          dispatch({ type: 'SET_DEPARTURE_DATE', payload: date });
          dispatch({
            type: 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE',
            payload: { date, status: 'NO_CONFIRMED' }
          });
          dispatch({ type: 'SET_DEPARTURE_FARE', payload: fare });
          dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: DEPARTURE_DATE });
          dispatch({ type: 'SET_FARE', payload: undefined });
          let start = date;
          if (
            isLastDayOfMonth(date) &&
            dayjs(date)
              .add(1, 'day')
              .isBefore(dayjs().startOf('month').add(numberOfMonths, 'month'), 'month')
          ) {
            start = dayjs(date).add(1, 'day').toDate();
          }
          if (isMobile) {
            globalDispatch({
              type: 'DATE_RANGE_HISTOGRAM_CHANGE',
              payload: {
                dateRange: {
                  start: start,
                  end: dayjs(start).endOf('month').toDate(),
                  departureDate: date,
                  action: 'SELECTED_DEPARTURE_DATE'
                },
                histogramType: 'INBOUND'
              }
            });
          } else {
            globalDispatch({
              type: 'DATE_RANGE_HISTOGRAM_CHANGE',
              payload: {
                dateRange: {
                  start: dayjs(dateRange.value.start).toDate(),
                  end: dayjs(dateRange.value.end).toDate(),
                  departureDate: date,
                  action: 'SELECTED_DEPARTURE_DATE'
                },
                histogramType: 'INBOUND'
              }
            });
          }
        } else {
          if (state.lastSelectedDate === DEPARTURE_DATE) {
            trackReturnDateSelection(date, dateRange);
            dispatch({ type: 'SET_RETURN_DATE', payload: date });
            if (!state.wasReturnDateSelected) {
              dispatch({ type: 'SET_WAS_RETURN_DATE_SELECTED', payload: true });
            }
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_RETURN_DATE',
              payload: { date, status: 'CONFIRMED' }
            });
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE',
              payload: { date: state.mobileDepartureDateConfirmed?.date, status: 'CONFIRMED' }
            });
            dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: RETURN_DATE });
            let newFare = { ...fare };
            if (newFare?.fareItem?.dataType === EMPTY_FROM_API) {
              newFare.fareItem.returnDate = dayjs(date).format('YYYY-MM-DD');
              newFare.fareItem.departureDate = dayjs(state.departureDate).format('YYYY-MM-DD');
              newFare.fareItem.flightType = isOneWayTrip ? ONE_WAY : ROUND_TRIP;
              newFare.fareItem.airlineCode = tenantCode;
            }
            dispatch({ type: 'SET_FARE', payload: newFare });
            dispatch({ type: 'SET_SHOW_CALENDAR_EMPTY', payload: true });
          } else if (state.lastSelectedDate === RETURN_DATE) {
            dispatch({ type: 'SET_FLAG_TO_NOT_SHOW_CALENDAR_EMPTY', payload: true });
            dispatch({
              type: 'SET_CHANGE_SELECTED_RETURN_DATE_CONFIRMED',
              payload: 'NO_CONFIRMED'
            });
            trackDepartureDateSelection(date, dateRange);
            dispatch({ type: 'SET_DEPARTURE_DATE', payload: date });
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE',
              payload: { date, status: 'NO_CONFIRMED' }
            });
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_RETURN_DATE',
              payload: { date: undefined, status: 'NO_CONFIRMED' }
            });
            dispatch({ type: 'SET_DEPARTURE_FARE', payload: fare });
            dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: DEPARTURE_DATE });
            dispatch({ type: 'SET_FARE', payload: undefined });
            dispatch({ type: 'SET_RETURN_DATE', payload: undefined });
            dispatch({ type: 'SET_LAST_HOVERED_DATE', payload: undefined });
            let start = date;
            if (
              isLastDayOfMonth(date) &&
              dayjs(date)
                .add(1, 'day')
                .isBefore(dayjs().startOf('month').add(numberOfMonths, 'month'), 'month')
            ) {
              start = dayjs(date).add(1, 'day').toDate();
            }
            if (isMobile) {
              globalDispatch({
                type: 'DATE_RANGE_HISTOGRAM_CHANGE',
                payload: {
                  dateRange: {
                    start: start,
                    end: dayjs(start).endOf('month').toDate(),
                    departureDate: date,
                    action: 'SELECTED_DEPARTURE_DATE'
                  },
                  histogramType: 'INBOUND'
                }
              });
            } else {
              globalDispatch({
                type: 'DATE_RANGE_HISTOGRAM_CHANGE',
                payload: {
                  dateRange: {
                    start: dayjs(dateRange.value.start).toDate(),
                    end: dayjs(dateRange.value.end).toDate(),
                    departureDate: date,
                    action: 'SELECTED_DEPARTURE_DATE'
                  },
                  histogramType: 'INBOUND'
                }
              });
            }
          }
        }
      }
    }
    if (isMobile) {
      focusDay(date);
    }
  };

  const getNameForTrackMonthChange = (date, dateRange) => {
    const currentMonth = dayjs(dateRange?.value?.start).month();
    const newMonth = dayjs(date).month();
    const currentYear = dayjs(dateRange?.value?.start).year();
    const newYear = dayjs(date).year();
    let name = '';
    if (newYear > currentYear || (newYear === currentYear && newMonth > currentMonth)) {
      name = 'MONTH_CHANGE_HISTOGRAM_FORWARD';
    } else if (newYear < currentYear || (newYear === currentYear && newMonth < currentMonth)) {
      name = 'MONTH_CHANGE_HISTOGRAM_BACK';
    }
    return name;
  };
  const handlerMonthNavigation = ({
    item,
    onSelectMonth,
    initialMonth,
    flightType,
    dateRange,
    isMobile
  }) => {
    dispatch({ type: 'SET_CONFIRMED_CHANGE_DEPARTURE_DATE', payload: false });
    const date = dayjs().set('month', item.month).set('year', item.year);
    const start =
      dayjs(date).diff(dayjs(initialMonth).startOf('month'), 'month') === 0
        ? initialMonth
        : date.startOf('month').toDate();

    dispatch({ type: 'SET_FIRST_DAY', payload: start });
    dispatch({ type: 'SET_FOCUS_DATE', payload: start });
    dispatch({ type: 'SET_AVOID_FOCUS_DATE_ACTION', payload: true });
    dispatch({ type: 'SET_CHANGE_CURRENT_MONTH', payload: true });

    if (state.showCalendarEmpty && !combinable) {
      const name = getNameForTrackMonthChange(date.toDate(), dateRange);
      onSelectMonth(name, {
        start,
        end: isMobile ? date.endOf('month').toDate() : date.add(1, 'month').endOf('month').toDate(),
        action: 'interval-completed',
        departureDate: state?.departureDate,
        returnDate: state?.returnDate,
        dateRange: {
          start: start,
          end: isMobile
            ? date.endOf('month').toDate()
            : date.add(1, 'month').endOf('month').toDate()
        }
      });
    } else {
      if (!state.lastSelectedDate) {
        //ONE_WAY
        const name = getNameForTrackMonthChange(date.toDate(), dateRange);
        onSelectMonth(name, {
          start,
          end: isMobile
            ? date.endOf('month').toDate()
            : date.add(1, 'month').endOf('month').toDate(),
          action: '-',
          departureDate: state?.departureDate,
          dateRange: {
            start: start,
            end: isMobile
              ? date.endOf('month').toDate()
              : date.add(1, 'month').endOf('month').toDate()
          }
        });
      } else {
        //COMBINABLE AND ROUND_TRIP
        const currentMonth = dayjs(dateRange?.value?.start).month();
        const newMonth = dayjs(date).month();
        let action = '-';
        if (newMonth > currentMonth) {
          action = 'NEXT_MONTH';
        } else {
          action = 'PREVIOUS_MONTH';
        }
        if (state.lastSelectedDate === DEPARTURE_DATE) {
          action = `${action}_${DEPARTURE_DATE}`;
          if (dayjs(state.departureDate).month() === item.month) {
            const name = getNameForTrackMonthChange(date.toDate(), dateRange);
            onSelectMonth(name, {
              start: flightType !== ONE_WAY ? state.departureDate : start,
              end: isMobile
                ? date.endOf('month').toDate()
                : date.add(1, 'month').endOf('month').toDate(),
              departureDate: state.departureDate,
              returnDate: state.returnDate,
              action: !combinable ? action : `combinable-destination-origin_${DEPARTURE_DATE}`,
              dateRange: {
                start: state.departureDate,
                end: isMobile
                  ? date.endOf('month').toDate()
                  : date.add(1, 'month').endOf('month').toDate()
              }
            });
          } else {
            const name = getNameForTrackMonthChange(date.toDate(), dateRange);
            onSelectMonth(name, {
              start,
              end: isMobile
                ? date.endOf('month').toDate()
                : date.add(1, 'month').endOf('month').toDate(),
              departureDate: state.departureDate,
              returnDate: state.returnDate,
              action: !combinable ? action : `combinable-destination-origin_${DEPARTURE_DATE}`,
              dateRange: {
                start: start,
                end: isMobile
                  ? date.endOf('month').toDate()
                  : date.add(1, 'month').endOf('month').toDate()
              }
            });
          }
        } else if (state.lastSelectedDate === RETURN_DATE) {
          action = `${action}_${RETURN_DATE}`;
          const name = getNameForTrackMonthChange(date.toDate(), dateRange);
          onSelectMonth(name, {
            start,
            end: isMobile
              ? date.endOf('month').toDate()
              : date.add(1, 'month').endOf('month').toDate(),
            departureDate: state.departureDate,
            returnDate: state.returnDate,
            action: !combinable
              ? action
              : !state.showCalendarEmpty
              ? `combinable-destination-origin_${RETURN_DATE}`
              : `combinable-origin-destination_${RETURN_DATE}`,
            dateRange: {
              start: start,
              end: isMobile
                ? date.endOf('month').toDate()
                : date.add(1, 'month').endOf('month').toDate()
            }
          });
        }
      }
    }
  };

  const handlerDayHover = (date) => {
    if (
      state.lastSelectedDate === DEPARTURE_DATE &&
      state.departureDate &&
      !state.returnDate &&
      dayjs(date).isAfter(state.departureDate) &&
      !dayjs(date).isSame(state.lastHoveredDate)
    ) {
      dispatch({ type: 'SET_LAST_HOVERED_DATE', payload: date });
    }
  };

  const handlerDataChange = (data, flightType, isMobile, filtersState) => {
    if (state.flagToNotShowCalendarEmpty) {
      dispatch({ type: 'SET_SHOW_CALENDAR_EMPTY', payload: false });
      dispatch({ type: 'SET_FLAG_TO_NOT_SHOW_CALENDAR_EMPTY', payload: false });
    }
    if (state.confirmedChangeDepartureDate === undefined) {
      dispatch({ type: 'SET_CONFIRMED_CHANGE_DEPARTURE_DATE', payload: false });
    } else if (
      state.confirmedChangeDepartureDate === false &&
      state.lastSelectedDate === DEPARTURE_DATE
    ) {
      dispatch({ type: 'SET_CONFIRMED_CHANGE_DEPARTURE_DATE', payload: true });
    }
    if (
      state.mobileDepartureDateConfirmed?.status === 'NO_CONFIRMED' &&
      state.mobileReturnDateConfirmed?.status === 'NO_CONFIRMED'
    ) {
      dispatch({
        type: 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE',
        payload: { date: state?.mobileDepartureDateConfirmed?.date, status: 'CONFIRMED' }
      });
      dispatch({
        type: 'SET_CHANGE_CONFIRMED_RETURN_DATE',
        payload: { date: state?.mobileReturnDateConfirmed?.date, status: 'CONFIRMED' }
      });
    }
    if (flightType !== ONE_WAY && combinable && state.updateDepartureFareData) {
      let newFare = data[data.length - 1];
      if (newFare) {
        if (newFare?.fareItem?.dataType === EMPTY_FROM_API) {
          newFare.fareItem.departureDate = dayjs(state.departureDate).format('YYYY-MM-DD');
          newFare.fareItem.flightType = ONE_WAY;
          newFare.fareItem.airlineCode = tenantCode;
        }
        dispatch({ type: 'SET_DEPARTURE_FARE', payload: newFare });
      }
      dispatch({ type: 'SET_UPDATE_DEPARTURE_FARE_DATA', payload: false });
    }
    if (flightType !== ONE_WAY && state.departureDate && state.returnDate && !combinable) {
      if (state.selectedReturnDateUpdated === 'NO_CONFIRMED') {
        let newFare = findFare(data, state.returnDate);
        if (newFare) {
          if (newFare?.fareItem?.dataType === EMPTY_FROM_API) {
            newFare.fareItem.returnDate = dayjs(state.returnDate).format('YYYY-MM-DD');
            newFare.fareItem.departureDate = dayjs(state.departureDate).format('YYYY-MM-DD');
            newFare.fareItem.flightType = ROUND_TRIP;
            newFare.fareItem.airlineCode = tenantCode;
          }
          dispatch({ type: 'SET_FARE', payload: newFare });
        }
      }
    }
    dispatch({ type: 'SET_CHANGE_SELECTED_RETURN_DATE_CONFIRMED', payload: undefined });
    if (state.changeFlightTypeFilter) {
      if (state.showCalendarEmpty) {
        dispatch({ type: 'SET_SHOW_CALENDAR_EMPTY', payload: false });
      }
      if (state.changeFlightTypeFilter.value !== ONE_WAY) {
        // One way to Round trip
        if (!combinable) {
          if (state.fare) {
            const fare = findFare(data, state.departureDate);
            if (fare) {
              dispatch({ type: 'SET_DEPARTURE_FARE', payload: fare });
            }
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE',
              payload: { date: state.departureDate, status: 'CONFIRMED' }
            });
            dispatch({ type: 'SET_FARE', payload: undefined });
            dispatch({ type: 'SET_RETURN_DATE', payload: undefined });
            dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: DEPARTURE_DATE });
            dispatch({ type: 'SET_LAST_HOVERED_DATE', payload: undefined });
          }
          if (!isMobile && state.departureDate && state.confirmedChangeDepartureDate === false) {
            dispatch({ type: 'SET_CONFIRMED_CHANGE_DEPARTURE_DATE', payload: true });
          }
        } else {
          if (state.fare) {
            dispatch({
              type: 'SET_CHANGE_CONFIRMED_DEPARTURE_DATE',
              payload: { date: state.departureDate, status: 'CONFIRMED' }
            });
            dispatch({ type: 'SET_RETURN_DATE', payload: undefined });
            dispatch({
              type: 'SET_DEPARTURE_FARE',
              payload: { ...state.fare, day: state.departureDate }
            });
            dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: DEPARTURE_DATE });
            dispatch({ type: 'SET_LAST_HOVERED_DATE', payload: undefined });
            dispatch({ type: 'SET_FARE', payload: undefined });
          }
          if (!isMobile && state.departureDate && state.confirmedChangeDepartureDate === false) {
            dispatch({ type: 'SET_CONFIRMED_CHANGE_DEPARTURE_DATE', payload: true });
          }
        }
        dispatch({ type: 'SET_CHANGE_FLIGHT_TYPE_FILTER', payload: undefined });
      } else {
        // Round trip to One way
        if (state.departureDate) {
          if (!combinable) {
            let fare;
            fare = findFare(data, state.departureDate);
            let newFare = { ...fare };
            if (newFare?.fareItem?.dataType === EMPTY_FROM_API) {
              newFare.fareItem.returnDate = dayjs(state.departureDate).format('YYYY-MM-DD');
              newFare.fareItem.departureDate = dayjs(state.departureDate).format('YYYY-MM-DD');
              newFare.fareItem.flightType = ONE_WAY;
              newFare.fareItem.airlineCode = tenantCode;
            }
            dispatch({ type: 'SET_FARE', payload: newFare });
            dispatch({ type: 'SET_DEPARTURE_FARE', payload: undefined });
            dispatch({ type: 'SET_RETURN_DATE', payload: undefined });
            dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: undefined });
          } else {
            dispatch({ type: 'SET_FARE', payload: state.departureFare });
            dispatch({ type: 'SET_DEPARTURE_FARE', payload: state.departureFare });
            dispatch({ type: 'SET_DEPARTURE_DATE', payload: state.departureDate });
            dispatch({ type: 'SET_RETURN_DATE', payload: undefined });
            dispatch({ type: 'SET_LAST_SELECTED_DATE', payload: undefined });
          }
        }

        dispatch({ type: 'SET_CHANGE_FLIGHT_TYPE_FILTER', payload: undefined });
      }
    }
    if (
      state.changeNumberOfStopFilter ||
      state.changeRedemptionUnitFilter ||
      state.changeTravelClassFilter
    ) {
      if (flightType === ONE_WAY) {
        if (state.fare) {
          const fare = findFare(data, state.departureDate);
          let newFare = { ...fare };
          if (newFare?.fareItem?.dataType === EMPTY_FROM_API) {
            newFare.fareItem.returnDate = dayjs(state.departureDate).format('YYYY-MM-DD');
            newFare.fareItem.departureDate = dayjs(state.departureDate).format('YYYY-MM-DD');
            newFare.fareItem.flightType = ONE_WAY;
            newFare.fareItem.airlineCode = tenantCode;
          }
          dispatch({ type: 'SET_FARE', payload: newFare });
        }
      } else {
        let fare;
        if (state.departureDate && state.returnDate) {
          if (!combinable) {
            if (state.lastSelectedDate === DEPARTURE_DATE) {
              fare = findFare(data, state.returnDate);
              if (fare) {
                if (fare?.fareItem?.dataType === EMPTY_FROM_API) {
                  fare.fareItem.returnDate = dayjs(state.returnDate).format('YYYY-MM-DD');
                  fare.fareItem.departureDate = dayjs(state.departureDate).format('YYYY-MM-DD');
                  fare.fareItem.flightType = ROUND_TRIP;
                  fare.fareItem.airlineCode = tenantCode;
                }
                dispatch({ type: 'SET_FARE', payload: fare });
                dispatch({
                  type: 'SET_DEPARTURE_FARE',
                  payload: { ...fare, day: state.departureDate }
                });
              }
            } else {
              if (
                state.showCalendarEmpty &&
                filtersState.dateRange?.value?.action.includes('interval-completed_filter-change')
              ) {
                let newFare = data[data.length - 1];
                if (newFare) {
                  if (newFare?.fareItem?.dataType === EMPTY_FROM_API) {
                    newFare.fareItem.departureDate = dayjs(state.departureDate).format(
                      'YYYY-MM-DD'
                    );
                    newFare.fareItem.flightType = ROUND_TRIP;
                    newFare.fareItem.airlineCode = tenantCode;
                  }
                  dispatch({ type: 'SET_FARE', payload: newFare });
                }
              } else {
                fare = findFare(data, state.returnDate);
                if (fare) {
                  if (fare?.fareItem?.dataType === EMPTY_FROM_API) {
                    fare.fareItem.returnDate = dayjs(state.returnDate).format('YYYY-MM-DD');
                    fare.fareItem.departureDate = dayjs(state.departureDate).format('YYYY-MM-DD');
                    fare.fareItem.flightType = ROUND_TRIP;
                    fare.fareItem.airlineCode = tenantCode;
                  }
                  dispatch({ type: 'SET_FARE', payload: fare });
                }
              }
            }
          } else {
            if (state.lastSelectedDate === DEPARTURE_DATE) {
              if (dayjs(data[0].day).month() !== dayjs(state.returnDate).month()) {
                if (dayjs(data[data.length - 1]?.day).isSame(dayjs(state.returnDate), 'day')) {
                  dispatch({
                    type: 'SET_FARE',
                    payload: {
                      ...data[data.length - 1],
                      fareItem: {
                        ...data[data.length - 1].fareItem,
                        flightType: !combinable ? flightType : ONE_WAY,
                        journeyType: !combinable
                          ? mapFlightTypeValue[flightType]
                          : mapFlightTypeValue[ONE_WAY]
                      }
                    }
                  });
                }
                if (dayjs(data[data.length - 2]?.day).isSame(dayjs(state.departureDate), 'day')) {
                  dispatch({
                    type: 'SET_DEPARTURE_FARE',
                    payload: { ...data[data.length - 2], day: state.departureDate }
                  });
                }
              } else {
                const fare = findFare(data, state.returnDate);
                if (fare) {
                  dispatch({
                    type: 'SET_FARE',
                    payload: {
                      ...fare,
                      fareItem: {
                        ...fare.fareItem,
                        flightType: !combinable ? flightType : ONE_WAY,
                        journeyType: !combinable
                          ? mapFlightTypeValue[flightType]
                          : mapFlightTypeValue[ONE_WAY]
                      }
                    }
                  });
                }
                if (dayjs(data[data.length - 1]?.day).isSame(dayjs(state.departureDate), 'day')) {
                  dispatch({
                    type: 'SET_DEPARTURE_FARE',
                    payload: { ...data[data.length - 1], day: state.departureDate }
                  });
                }
              }
            } else {
              if (dayjs(data[0].day).month() !== dayjs(state.departureDate).month()) {
                if (dayjs(data[data.length - 1]?.day).isSame(dayjs(state.returnDate), 'day')) {
                  dispatch({
                    type: 'SET_FARE',
                    payload: {
                      ...data[data.length - 1],
                      fareItem: {
                        ...data[data.length - 1].fareItem,
                        flightType: !combinable ? flightType : ONE_WAY,
                        journeyType: !combinable
                          ? mapFlightTypeValue[flightType]
                          : mapFlightTypeValue[ONE_WAY]
                      }
                    }
                  });
                }
                if (dayjs(data[data.length - 2]?.day).isSame(dayjs(state.departureDate), 'day')) {
                  dispatch({
                    type: 'SET_DEPARTURE_FARE',
                    payload: { ...data[data.length - 2], day: state.departureDate }
                  });
                }
              } else {
                let fare = findFare(data, state.departureDate);
                if (dayjs(data[data.length - 2]?.day).isSame(dayjs(state.departureDate), 'day')) {
                  fare = { ...data[data.length - 2], day: state.departureDate };
                }
                if (fare) {
                  dispatch({ type: 'SET_DEPARTURE_FARE', payload: fare });
                }
                if (dayjs(data[data.length - 1]?.day).isSame(dayjs(state.returnDate), 'day')) {
                  dispatch({
                    type: 'SET_FARE',
                    payload: {
                      ...data[data.length - 1],
                      fareItem: {
                        ...data[data.length - 1].fareItem,
                        flightType: !combinable ? flightType : ONE_WAY,
                        journeyType: !combinable
                          ? mapFlightTypeValue[flightType]
                          : mapFlightTypeValue[ONE_WAY]
                      }
                    }
                  });
                }
              }
            }
          }
        } else if (state.departureDate) {
          if (combinable && state.departureDate) {
            fare = data[data.length - 1];
            if (fare) {
              if (fare?.fareItem?.dataType === EMPTY_FROM_API) {
                fare.fareItem.departureDate = dayjs(state.departureDate).format('YYYY-MM-DD');
                fare.fareItem.flightType = ONE_WAY;
                fare.fareItem.airlineCode = tenantCode;
              }
              dispatch({ type: 'SET_DEPARTURE_FARE', payload: fare });
            }
          } else {
            fare = findFare(data, state.departureDate);
            if (fare) {
              dispatch({ type: 'SET_DEPARTURE_FARE', payload: fare });
            }
          }
        }
      }
      dispatch({ type: 'SET_CHANGE_TRAVEL_CLASS_FILTER', payload: undefined });
      dispatch({ type: 'SET_CHANGE_REDEMPTION_UNIT_FILTER', payload: undefined });
      dispatch({ type: 'SET_CHANGE_NUMBER_OF_STOP_FILTER', payload: undefined });
    }
  };

  const getDefaultSettingsMobile = (
    settings,
    travelClassValue,
    flightTypeValue,
    dateFormat,
    isRedemptionUnitPoints
  ) => {
    let departureDate;
    let formattedDepartureDate;
    if (state.departureDate) {
      departureDate = ingloriousMomentNeverUseMe(state.departureDate).format('YYYY-MM-DD');
      formattedDepartureDate = ingloriousMomentNeverUseMe(departureDate).format(dateFormat);
    } else {
      departureDate = translate('cmp-low-fare-calendaroi2-departure-date-mobile', '--');
      formattedDepartureDate = translate(
        'cmp-low-fare-calendaroi2-formatted-departure-date-mobile',
        '--'
      );
    }
    settings = {
      ...settings,
      fareItemPrice: {
        ...settings.fareItemPrice,
        showPriceDisclaimer: false,
        pricePromoLabelKey: 'cmp-preposition-mobile-total-price'
      },
      fareItemMiles: {
        ...settings.fareItemMiles,
        showPriceDisclaimer: false,
        milesPromoLabelKey: isRedemptionUnitPoints
          ? 'cmp-preposition-mobile-total-price-points'
          : 'cmp-preposition-mobile-total-price-miles',
        showMilesDisclaimer: true,
        showCurrencyCode: true,
        showCurrencySymbolSub: false,
        currencyInFront: true,
        showCurrencySymbol: false,
        showMilesPromo: true,
        showShortMiles: false,
        showFormattedTaxAmount: false,
        showTaxAmountSymbol: false,
        milesSymbol: isRedemptionUnitPoints ? 'empty-points' : 'empty-miles'
      },
      fareItemCallToAction: {
        ...settings.fareItemCallToAction,
        callToAction: {
          ...settings.fareItemCallToAction.callToAction,
          disabled: true
        }
      },
      data: {
        departureDate,
        formattedDepartureDate,
        formattedReturnDate: translate(
          'cmp-low-fare-calendaroi2-formatted-return-date-mobile',
          '--'
        ),
        returnDate: translate('cmp-low-fare-calendaroi2-return-date-mobile', '--'),
        formattedTotalPrice: translate('cmp-low-fare-calendaroi2-formated-total-price', '--'),
        shortenedFormattedTotalPrice: translate('cmp-low-fare-calendaroi2-details-price', '--'),
        formattedTotalPriceForMobile: translate(
          'cmp-low-fare-calendaroi2-formated-total-price',
          '--'
        ),
        shortenedFormattedTotalPriceForMobile: translate(
          'cmp-low-fare-calendaroi2-details-price',
          '--'
        ),
        flightType: flightTypeValue,
        journeyType: mapFlightTypeValue[flightTypeValue],
        farenetTravelClass: travelClassValue,
        travelClass: travelClassValue
      }
    };
    return settings;
  };

  const getSettingsFareItemMediumSize = ({
    fareItemAtomSettings,
    isOriginDestinationFilled,
    travelClassValue,
    flightTypeValue,
    redemptionUnit,
    isMobile,
    loading
  }) => {
    let settings = { ...fareItemAtomSettings };

    const showTravelClass = fareItemAtomSettings?.showTravelClass;
    const showJourneyType = fareItemAtomSettings?.showJourneyType;
    const showDepartureInfo = fareItemAtomSettings?.showDepartureInfo;
    const showReturnInfo = fareItemAtomSettings?.showReturnInfo;
    const showLastSeen = fareItemAtomSettings?.showLastSeen;
    const showPriceAtom = fareItemAtomSettings?.showPriceAtom;

    const isOneWayTrip = flightTypeValue === ONE_WAY;
    const isRedemptionUnitMilesOrPoints = redemptionUnit !== CASH;
    const isRedemptionUnitPoints = redemptionUnit === POINTS;
    const atoms = settings.availableAtomsBody;
    const element = isRedemptionUnitMilesOrPoints ? 'FareItemMiles' : 'FareItemPrice';
    const dateFormat = settings.fareItemDepartureInfo?.dateFormat ?? 'MMM D, YYYY';

    if (loading && (state.changeFlightTypeFilter || state.changeRedemptionUnitFilter)) {
      settings = {
        ...settings,
        availableAtomsBody: updateAvailableAtomsBody(atoms, element),
        showPrice: showPriceAtom ? !isRedemptionUnitMilesOrPoints : false,
        showMiles: showPriceAtom ? isRedemptionUnitMilesOrPoints : false,
        showLastSeen: state.fare ? showLastSeen : false,
        showTravelClass: isOriginDestinationFilled ? showTravelClass : false,
        showJourneyType:
          !isOriginDestinationFilled && (showTravelClass || showJourneyType)
            ? true
            : showJourneyType,
        showDepartureInfo,
        showReturnInfo: !isOneWayTrip ? showReturnInfo : false
      };
      if (!showPriceAtom && !isMobile) {
        settings = {
          ...settings,
          fareItemJourneyTypeTravelClass: {
            'cmp-styles': {
              ...settings.fareItemJourneyTypeTravelClass['cmp-styles'],
              'padding-top': '25px'
            }
          }
        };
      }
      let loadingSettings;
      if (!isMobile) {
        loadingSettings = getDefaultSettings(
          settings,
          isOneWayTrip,
          isOriginDestinationFilled,
          travelClassValue,
          flightTypeValue,
          dateFormat,
          isRedemptionUnitPoints,
          isMobile
        );
      } else {
        settings = {
          ...settings,
          availableAtomsBody: updateExperimentelAtoms(atoms, element),
          showPrice: showPriceAtom ? !isRedemptionUnitMilesOrPoints : false,
          showMiles: showPriceAtom ? isRedemptionUnitMilesOrPoints : false,
          showLastSeen: state.fare ? showLastSeen : false,
          showTravelClass: isOriginDestinationFilled ? showTravelClass : false,
          showJourneyType:
            !isOriginDestinationFilled && (showTravelClass || showJourneyType)
              ? true
              : showJourneyType,
          showDepartureInfo,
          showReturnInfo: !isOneWayTrip ? showReturnInfo : false
        };
        if (!showPriceAtom && !isMobile) {
          settings = {
            ...settings,
            fareItemJourneyTypeTravelClass: {
              'cmp-styles': {
                ...settings.fareItemJourneyTypeTravelClass['cmp-styles'],
                'padding-top': '25px'
              }
            }
          };
        }
        loadingSettings = getDefaultSettingsMobile(
          settings,
          travelClassValue,
          flightTypeValue,
          dateFormat,
          isRedemptionUnitPoints
        );
      }
      loadingSettings = {
        ...loadingSettings,
        fareItemPrice: {
          ...loadingSettings.fareItemPrice,
          showCurrencyCode: true,
          currencyToDisplay: ''
        },
        fareItemMiles: {
          ...loadingSettings.fareItemMiles,
          showCurrencyCode: true,
          currencyToDisplay: ''
        }
      };
      if (!isMobile) {
        if (isOneWayTrip) {
          if (state.departureDate) {
            loadingSettings = {
              ...loadingSettings,
              fareItemDepartureInfo: { ...settings.fareItemDepartureInfoComplete }
            };
          }
        } else {
          if (state.departureDate && state.returnDate) {
            loadingSettings = {
              ...loadingSettings,
              fareItemDepartureInfo: { ...settings.fareItemDepartureInfoComplete },
              fareItemReturnInfo: { ...settings.fareItemReturnInfoComplete },
              separatorDatesProps: { ...settings.separatorDatesPropsComplete }
            };
          }
        }
      }
      if (!loadingSettings?.data?.searchDate) {
        loadingSettings = {
          ...loadingSettings,
          showLastSeen: false
        };
      }
      return loadingSettings;
    }

    if (!isMobile) {
      settings = {
        ...settings,
        availableAtomsBody: updateAvailableAtomsBody(atoms, element),
        showPrice: showPriceAtom ? !isRedemptionUnitMilesOrPoints : false,
        showMiles: showPriceAtom ? isRedemptionUnitMilesOrPoints : false,
        showLastSeen: state.fare ? showLastSeen : false,
        showTravelClass: showTravelClass,
        showJourneyType:
          !isOriginDestinationFilled && (showTravelClass || showJourneyType)
            ? true
            : showJourneyType,
        showDepartureInfo,
        showReturnInfo: !isOneWayTrip ? showReturnInfo : false
      };
      if (!showPriceAtom && !isMobile) {
        settings = {
          ...settings,
          fareItemJourneyTypeTravelClass: {
            'cmp-styles': {
              ...settings.fareItemJourneyTypeTravelClass['cmp-styles'],
              'padding-top': '25px'
            }
          }
        };
      }
      if (!state.fare) {
        settings = getDefaultSettings(
          settings,
          isOneWayTrip,
          isOriginDestinationFilled,
          travelClassValue,
          flightTypeValue,
          dateFormat,
          isRedemptionUnitPoints,
          isMobile
        );
      } else {
        settings = getFareSettings(
          settings,
          isOneWayTrip,
          dateFormat,
          travelClassValue,
          flightTypeValue,
          isRedemptionUnitMilesOrPoints,
          isRedemptionUnitPoints
        );
      }
    } else {
      settings = {
        ...settings,
        availableAtomsBody: updateExperimentelAtoms(atoms, element),
        showPrice: showPriceAtom ? !isRedemptionUnitMilesOrPoints : false,
        showMiles: showPriceAtom ? isRedemptionUnitMilesOrPoints : false,
        showLastSeen: state.fare ? showLastSeen : false,
        showTravelClass: isOriginDestinationFilled ? showTravelClass : false,
        showJourneyType:
          !isOriginDestinationFilled && (showTravelClass || showJourneyType)
            ? true
            : showJourneyType,
        showDepartureInfo,
        showReturnInfo: !isOneWayTrip ? showReturnInfo : false
      };
      if (!showPriceAtom && !isMobile) {
        settings = {
          ...settings,
          fareItemJourneyTypeTravelClass: {
            'cmp-styles': {
              ...settings.fareItemJourneyTypeTravelClass['cmp-styles'],
              'padding-top': '25px'
            }
          }
        };
      }
      if (!state.fare) {
        let departureDate;
        let formattedDepartureDate;
        if (state.departureDate) {
          departureDate = ingloriousMomentNeverUseMe(state.departureDate).format('YYYY-MM-DD');
          formattedDepartureDate = ingloriousMomentNeverUseMe(departureDate).format(dateFormat);
        } else {
          departureDate = translate('cmp-low-fare-calendaroi2-departure-date-mobile', '--');
          formattedDepartureDate = translate(
            'cmp-low-fare-calendaroi2-formatted-departure-date-mobile',
            '--'
          );
        }
        settings = {
          ...settings,
          fareItemPrice: {
            ...settings.fareItemPrice,
            showPriceDisclaimer: false,
            pricePromoLabelKey: 'cmp-preposition-mobile-total-price'
          },
          fareItemMiles: {
            ...settings.fareItemMiles,
            showPriceDisclaimer: false,
            milesPromoLabelKey: isRedemptionUnitPoints
              ? 'cmp-preposition-mobile-total-price-points'
              : 'cmp-preposition-mobile-total-price-miles',
            showMilesDisclaimer: true,
            showCurrencyCode: true,
            showCurrencySymbolSub: false,
            currencyInFront: true,
            showCurrencySymbol: false,
            showMilesPromo: true,
            showShortMiles: false,
            showFormattedTaxAmount: false,
            showTaxAmountSymbol: false,
            milesSymbol: isRedemptionUnitPoints ? 'empty-points' : 'empty-miles'
          },
          fareItemCallToAction: {
            ...settings.fareItemCallToAction,
            callToAction: {
              ...settings.fareItemCallToAction.callToAction,
              disabled: true
            }
          },
          data: {
            departureDate,
            formattedDepartureDate,
            formattedReturnDate: translate(
              'cmp-low-fare-calendaroi2-formatted-return-date-mobile',
              '--'
            ),
            returnDate: translate('cmp-low-fare-calendaroi2-return-date-mobile', '--'),
            formattedTotalPrice: translate('cmp-low-fare-calendaroi2-formated-total-price', '--'),
            shortenedFormattedTotalPrice: translate('cmp-low-fare-calendaroi2-details-price', '--'),
            formattedTotalPriceForMobile: translate(
              'cmp-low-fare-calendaroi2-formated-total-price',
              '--'
            ),
            shortenedFormattedTotalPriceForMobile: translate(
              'cmp-low-fare-calendaroi2-details-price',
              '--'
            ),
            flightType: flightTypeValue,
            journeyType: mapFlightTypeValue[flightTypeValue],
            farenetTravelClass: travelClassValue,
            travelClass: travelClassValue
          }
        };
      } else {
        const fare = state.fare.fareItem;
        if (isOneWayTrip) {
          if (fare.dataType === EMPTY_FROM_API) {
            const departureDate = fare.departureDate;
            const formattedDepartureDate = ingloriousMomentNeverUseMe(departureDate).format(
              dateFormat
            );
            settings = {
              ...settings,
              showLastSeen: false,
              fareItemPrice: {
                ...settings.fareItemPrice,
                showPriceDisclaimer: false,
                pricePromoLabelKey: 'cmp-preposition-mobile-total-price'
              },
              fareItemMiles: {
                ...settings.fareItemMiles,
                milesPromoLabelKey: isRedemptionUnitPoints
                  ? 'cmp-preposition-mobile-total-price-points'
                  : 'cmp-preposition-mobile-total-price-miles',
                showMilesDisclaimer: true,
                showCurrencyCode: true,
                showCurrencySymbolSub: false,
                currencyInFront: true,
                showCurrencySymbol: false,
                showMilesPromo: true,
                showShortMiles: false,
                showFormattedTaxAmount: false,
                showTaxAmountSymbol: false,
                milesSymbol: isRedemptionUnitPoints ? 'empty-points' : 'empty-miles'
              },
              data: {
                ...fare,
                formattedDepartureDate,
                flightType: flightTypeValue,
                journeyType: mapFlightTypeValue[flightTypeValue],
                farenetTravelClass: travelClassValue,
                travelClass: travelClassValue,
                formattedTotalPrice: translate(
                  'cmp-low-fare-calendaroi2-formated-total-price',
                  '--'
                ),
                shortenedFormattedTotalPrice: translate(
                  'cmp-low-fare-calendaroi2-details-price',
                  '--'
                ),
                formattedTotalPriceForMobile: translate(
                  'cmp-low-fare-calendaroi2-formated-total-price',
                  '--'
                ),
                shortenedFormattedTotalPriceForMobile: translate(
                  'cmp-low-fare-calendaroi2-details-price',
                  '--'
                )
              }
            };
          } else {
            const departureDate = fare.formattedDepartureDate;
            const formattedDepartureDate = ingloriousMomentNeverUseMe(departureDate).format(
              dateFormat
            );
            settings = {
              ...settings,
              fareItemPrice: {
                ...settings.fareItemPrice,
                pricePromoLabelKey: 'cmp-preposition-rt-total-price',
                showPriceDisclaimer: true
              },
              fareItemMiles: {
                ...settings.fareItemMiles,
                milesPromoLabelKey: isRedemptionUnitPoints
                  ? 'cmp-preposition-rt-points-total-price'
                  : 'cmp-preposition-rt-miles-total-price',
                showMilesDisclaimer: true,
                showCurrencyCode: true,
                showCurrencySymbolSub: false,
                currencyInFront: true,
                showCurrencySymbol: false,
                showMilesPromo: true,
                showShortMiles: false,
                showFormattedTaxAmount: true,
                showTaxAmountSymbol: true
              },
              data: {
                ...fare,
                formattedDepartureDate
              }
            };
          }
        } else {
          if (fare.dataType === EMPTY_FROM_API) {
            const departureDate = state.departureDate;
            const formattedDepartureDate = ingloriousMomentNeverUseMe(departureDate).format(
              dateFormat
            );
            settings = {
              ...settings,
              showLastSeen: false,
              fareItemPrice: {
                ...settings.fareItemPrice,
                showPriceDisclaimer: false,
                pricePromoLabelKey: 'cmp-preposition-rt-total-price'
              },
              fareItemMiles: {
                ...settings.fareItemMiles,
                milesPromoLabelKey: isRedemptionUnitPoints
                  ? 'cmp-preposition-rt-points-total-price'
                  : 'cmp-preposition-rt-miles-total-price',
                milesSymbol: isRedemptionUnitPoints ? 'empty-points' : 'empty-miles',
                showMilesDisclaimer: false,
                showCurrencyCode: false,
                showCurrencySymbolSub: false,
                currencyInFront: false,
                showCurrencySymbol: false,
                showMilesPromo: true,
                showShortMiles: false,
                showFormattedTaxAmount: true,
                showTaxAmountSymbol: false
              },
              data: {
                ...state.fare.fareItem,
                formattedDepartureDate,
                flightType: flightTypeValue,
                journeyType: mapFlightTypeValue[flightTypeValue],
                farenetTravelClass: travelClassValue,
                travelClass: travelClassValue,
                formattedTotalPrice: translate(
                  'cmp-low-fare-calendaroi2-formated-total-price',
                  '--'
                ),
                shortenedFormattedTotalPrice: translate(
                  'cmp-low-fare-calendaroi2-details-price',
                  '--'
                ),
                formattedTotalPriceForMobile: translate(
                  'cmp-low-fare-calendaroi2-formated-total-price',
                  '--'
                ),
                shortenedFormattedTotalPriceForMobile: translate(
                  'cmp-low-fare-calendaroi2-details-price',
                  '--'
                ),
                returnDate: ingloriousMomentNeverUseMe(state.returnDate).format('YYYY-MM-DD'),
                formattedReturnDate: ingloriousMomentNeverUseMe(state.returnDate).format(dateFormat)
              }
            };
          } else {
            settings = {
              ...settings,
              fareItemPrice: {
                ...settings.fareItemPrice,
                pricePromoLabelKey: 'cmp-preposition-rt-total-price',
                showPriceDisclaimer: true
              },
              fareItemMiles: {
                ...settings.fareItemMiles,
                milesPromoLabelKey: isRedemptionUnitPoints
                  ? 'cmp-preposition-rt-points-total-price'
                  : 'cmp-preposition-rt-miles-total-price',
                showMilesDisclaimer: true,
                showCurrencyCode: true,
                showCurrencySymbolSub: false,
                currencyInFront: true,
                showCurrencySymbol: false,
                showMilesPromo: true,
                showShortMiles: false,
                showFormattedTaxAmount: true,
                showTaxAmountSymbol: true
              },
              data: {
                ...state.fare.fareItem,
                formattedDepartureDate: ingloriousMomentNeverUseMe(state.departureDate).format(
                  dateFormat
                ),
                returnDate: ingloriousMomentNeverUseMe(state.returnDate).format('YYYY-MM-DD'),
                formattedReturnDate: ingloriousMomentNeverUseMe(state.returnDate).format(dateFormat)
              }
            };
          }
          if (combinable) {
            settings = {
              ...getCombinableDetailsPrice(
                settings,
                isRedemptionUnitMilesOrPoints,
                isRedemptionUnitPoints
              )
            };
          }
        }
      }
    }
    settings = updateShowCurrencyCode(settings, state.fare, isOneWayTrip);
    if (!isMobile) {
      if (isOneWayTrip) {
        if (state.departureDate) {
          settings = {
            ...settings,
            fareItemDepartureInfo: { ...settings.fareItemDepartureInfoComplete }
          };
        }
      } else {
        if (state.departureDate && state.returnDate) {
          settings = {
            ...settings,
            fareItemDepartureInfo: { ...settings.fareItemDepartureInfoComplete },
            fareItemReturnInfo: { ...settings.fareItemReturnInfoComplete },
            separatorDatesProps: { ...settings.separatorDatesPropsComplete }
          };
        }
      }
    }
    return settings;
  };

  const getDefaultSettings = (
    settings,
    isOneWayTrip,
    isOriginDestinationFilled,
    travelClassValue,
    flightTypeValue,
    dateFormat,
    isRedemptionUnitPoints,
    isMobile
  ) => {
    let departureDate;
    let formattedDepartureDate;
    let searchDate;
    if (state.departureDate) {
      departureDate = ingloriousMomentNeverUseMe(state.departureDate).format('YYYY-MM-DD');
      formattedDepartureDate = ingloriousMomentNeverUseMe(departureDate).format(dateFormat);
    } else {
      departureDate = translate('cmp-low-fare-calendaroi2-departure-date', 'Departure Date');
      formattedDepartureDate = translate(
        'cmp-low-fare-calendaroi2-formatted-departure-date',
        'Departure Date'
      );
    }
    let returnDate;
    let formattedReturnDate;
    if (state.returnDate) {
      returnDate = ingloriousMomentNeverUseMe(state.returnDate).format('YYYY-MM-DD');
      formattedReturnDate = ingloriousMomentNeverUseMe(returnDate).format(dateFormat);
    } else {
      returnDate = translate('cmp-low-fare-calendaroi2-return-date', 'Return Date');
      formattedReturnDate = translate(
        'cmp-low-fare-calendaroi2-formatted-return-date',
        'Return Date'
      );
    }
    if (
      flightTypeValue !== ONE_WAY &&
      state.departureDate &&
      state?.departureFare?.fareItem?.dataType === 'DATA_API'
    ) {
      searchDate = state?.departureFare?.fareItem?.searchDate;
    }
    settings = {
      ...settings,
      fareItemPrice: {
        ...settings.fareItemPrice,
        showPriceDisclaimer: false
      },
      fareItemMiles: {
        ...settings.fareItemMiles,
        milesSymbol: isRedemptionUnitPoints ? 'empty-points' : 'empty-miles'
      },
      fareItemCallToAction: {
        ...settings.fareItemCallToAction,
        callToAction: {
          ...settings.fareItemCallToAction.callToAction,
          disabled: true
        }
      },
      data: {
        departureDate,
        formattedDepartureDate,
        formattedReturnDate,
        returnDate,
        formattedTotalPrice: translate('cmp-low-fare-calendaroi2-formated-total-price', '--'),
        shortenedFormattedTotalPrice: translate('cmp-low-fare-calendaroi2-details-price', '--'),
        formattedTotalPriceForMobile: translate(
          'cmp-low-fare-calendaroi2-formated-total-price',
          '--'
        ),
        shortenedFormattedTotalPriceForMobile: translate(
          'cmp-low-fare-calendaroi2-details-price',
          '--'
        ),
        journeyType: isMobile ? 'empty' : mapFlightTypeValue[flightTypeValue],
        farenetTravelClass: isMobile ? undefined : travelClassValue,
        travelClass: isMobile ? undefined : travelClassValue,
        searchDate
      }
    };

    if (isOriginDestinationFilled) {
      settings = {
        ...settings,
        fareItemPrice: {
          ...settings.fareItemPrice,
          pricePromoLabelKey: isOneWayTrip
            ? 'cmp-preposition-ow-total-price'
            : 'cmp-preposition-rt-total-price'
        },
        fareItemMiles: {
          ...settings.fareItemMiles,
          milesPromoLabelKey: isOneWayTrip
            ? isRedemptionUnitPoints
              ? 'cmp-preposition-ow-points-total-price'
              : 'cmp-preposition-ow-miles-total-price'
            : isRedemptionUnitPoints
            ? 'cmp-preposition-rt-points-total-price'
            : 'cmp-preposition-rt-miles-total-price'
        },
        data: {
          ...settings.data,
          flightType: flightTypeValue,
          journeyType: mapFlightTypeValue[flightTypeValue],
          farenetTravelClass: travelClassValue,
          travelClass: travelClassValue
        }
      };
    }

    return settings;
  };

  const getFareSettings = (
    settings,
    isOneWayTrip,
    dateFormat,
    travelClassValue,
    flightTypeValue,
    isRedemptionUnitMilesOrPoints,
    isRedemptionUnitPoints
  ) => {
    const fare = state.fare.fareItem;

    if (isOneWayTrip) {
      if (fare.dataType === EMPTY_FROM_API) {
        const departureDate = state.fare.fareItem.departureDate;
        const formattedDepartureDate = ingloriousMomentNeverUseMe(departureDate).format(dateFormat);

        settings = getEmptyFareSettings(
          settings,
          formattedDepartureDate,
          travelClassValue,
          flightTypeValue,
          'cmp-preposition-ow-total-price',
          isRedemptionUnitPoints
            ? 'cmp-preposition-ow-points-total-price'
            : 'cmp-preposition-ow-miles-total-price',
          isRedemptionUnitPoints
        );
      } else {
        const departureDate = state.fare.fareItem.departureDate;
        const formattedDepartureDate = ingloriousMomentNeverUseMe(departureDate).format(dateFormat);
        settings = getFilledFareSettings(
          settings,
          formattedDepartureDate,
          'cmp-preposition-ow-total-price',
          isRedemptionUnitPoints
            ? 'cmp-preposition-ow-points-total-price'
            : 'cmp-preposition-ow-miles-total-price'
        );
      }
    } else {
      settings = getRoundTripFareSettings(
        settings,
        dateFormat,
        travelClassValue,
        flightTypeValue,
        fare,
        isRedemptionUnitMilesOrPoints,
        isRedemptionUnitPoints
      );
    }

    return settings;
  };

  const getEmptyFareSettings = (
    settings,
    formattedDepartureDate,
    travelClassValue,
    flightTypeValue,
    pricePromoLabelKey,
    milesPromoLabelKey,
    isRedemptionUnitPoints
  ) => {
    return {
      ...settings,
      showLastSeen: false,
      fareItemPrice: {
        ...settings.fareItemPrice,
        showPriceDisclaimer: false,
        pricePromoLabelKey
      },
      fareItemMiles: {
        ...settings.fareItemMiles,
        milesPromoLabelKey,
        milesSymbol: isRedemptionUnitPoints ? 'empty-points' : 'empty-miles',
        showMilesDisclaimer: false,
        showCurrencyCode: false,
        showCurrencySymbolSub: false,
        currencyInFront: false,
        showCurrencySymbol: false,
        showMilesPromo: true,
        showShortMiles: false,
        showFormattedTaxAmount: true,
        showTaxAmountSymbol: false
      },
      data: {
        ...state.fare.fareItem,
        formattedDepartureDate,
        flightType: flightTypeValue,
        journeyType: mapFlightTypeValue[flightTypeValue],
        farenetTravelClass: travelClassValue,
        travelClass: travelClassValue,
        formattedTotalPrice: translate('cmp-low-fare-calendaroi2-formated-total-price', '--'),
        shortenedFormattedTotalPrice: translate('cmp-low-fare-calendaroi2-details-price', '--'),
        formattedTotalPriceForMobile: translate(
          'cmp-low-fare-calendaroi2-formated-total-price',
          '--'
        ),
        shortenedFormattedTotalPriceForMobile: translate(
          'cmp-low-fare-calendaroi2-details-price',
          '--'
        )
      }
    };
  };

  const getFilledFareSettings = (
    settings,
    formattedDepartureDate,
    pricePromoLabelKey,
    milesPromoLabelKey
  ) => {
    return {
      ...settings,
      fareItemPrice: {
        ...settings.fareItemPrice,
        pricePromoLabelKey,
        showPriceDisclaimer: true
      },
      fareItemMiles: {
        ...settings.fareItemMiles,
        milesPromoLabelKey,
        showMilesDisclaimer: true,
        showCurrencyCode: true,
        showCurrencySymbolSub: false,
        currencyInFront: true,
        showCurrencySymbol: false,
        showMilesPromo: true,
        showShortMiles: false,
        showFormattedTaxAmount: true,
        showTaxAmountSymbol: true
      },
      data: {
        ...state.fare.fareItem,
        formattedDepartureDate
      }
    };
  };

  const getCombinableDetailsPrice = (
    oldSettings,
    isRedemptionUnitMilesOrPoints,
    isRedemptionUnitPoints
  ) => {
    let settings = { ...oldSettings };
    let amount, taxAmount;
    if (isRedemptionUnitMilesOrPoints) {
      if (
        state?.departureFare?.fareItem?.redemption?.amount &&
        state?.fare?.fareItem?.redemption?.amount
      ) {
        amount =
          state?.departureFare?.fareItem?.redemption?.amount +
          state?.fare?.fareItem?.redemption?.amount;
        taxAmount = parseFloat(
          state.departureFare?.fareItem?.redemption?.taxAmount +
            state.fare.fareItem?.redemption?.taxAmount
        ).toFixed(2);
        settings = {
          ...settings,
          data: {
            ...settings.data,
            redemption: {
              ...settings.data?.redemption,
              formattedAmount: amount,
              shortenedFormattedTotalPrice: amount,
              formattedTaxAmount: taxAmount
            }
          }
        };
      } else {
        settings = {
          ...settings,
          fareItemMiles: {
            ...settings.fareItemMiles,
            showPriceDisclaimer: false,
            showMilesDisclaimer: false,
            showCurrencyCode: false,
            showCurrencySymbolSub: false,
            currencyInFront: true,
            showCurrencySymbol: false,
            showMilesPromo: true,
            showShortMiles: false,
            showFormattedTaxAmount: false,
            showTaxAmountSymbol: false,
            milesSymbol: isRedemptionUnitPoints ? 'empty-points' : 'empty-miles'
          },
          data: {
            ...settings.data,
            redemption: {
              ...settings.data?.redemption,
              formattedAmount: translate('cmp-low-fare-calendaroi2-details-total-amount', ' '),
              shortenedFormattedTotalPrice: translate(
                'cmp-low-fare-calendaroi2-details-total-amount',
                ' '
              ),
              formattedTaxAmount: translate('cmp-low-fare-calendaroi2-details-total-tax', ' ')
            }
          }
        };
      }
    } else {
      if (state?.departureFare?.fareItem?.totalPrice && state?.fare?.fareItem?.totalPrice) {
        amount = state?.departureFare?.fareItem?.totalPrice + state?.fare?.fareItem?.totalPrice;
        settings = {
          ...settings,
          data: {
            ...settings.data,
            shortenedFormattedTotalPrice: amount,
            formattedTotalPrice: amount
          }
        };
      } else {
        settings = {
          ...settings,
          fareItemPrice: {
            ...settings.fareItemPrice,
            showPriceDisclaimer: false
          },
          data: {
            ...settings.data,
            shortenedFormattedTotalPrice: translate('cmp-low-fare-calendaroi2-details-price', '--'),
            formattedTotalPrice: translate('cmp-low-fare-calendaroi2-details-price', '--'),
            formattedTotalPriceForMobile: translate('cmp-low-fare-calendaroi2-details-price', '--'),
            shortenedFormattedTotalPriceForMobile: translate(
              'cmp-low-fare-calendaroi2-details-price',
              '--'
            )
          }
        };
      }
    }
    return settings;
  };

  const getRoundTripFareSettings = (
    settings,
    dateFormat,
    travelClassValue,
    flightTypeValue,
    fare,
    isRedemptionUnitMilesOrPoints,
    isRedemptionUnitPoints
  ) => {
    const formattedDepartureDate = ingloriousMomentNeverUseMe(state.departureDate).format(
      dateFormat
    );
    const formattedReturnDate = ingloriousMomentNeverUseMe(state.returnDate).format(dateFormat);

    if (fare.dataType === EMPTY_FROM_API) {
      settings = getEmptyFareSettings(
        settings,
        formattedDepartureDate,
        travelClassValue,
        flightTypeValue,
        'cmp-preposition-rt-total-price',
        isRedemptionUnitPoints
          ? 'cmp-preposition-rt-points-total-price'
          : 'cmp-preposition-rt-miles-total-price',
        isRedemptionUnitPoints
      );
      settings = {
        ...settings,
        data: {
          ...settings.data,
          returnDate: ingloriousMomentNeverUseMe(state.returnDate).format('YYYY-MM-DD'),
          formattedReturnDate
        }
      };
    } else {
      settings = getFilledFareSettings(
        settings,
        formattedDepartureDate,
        'cmp-preposition-rt-total-price',
        isRedemptionUnitPoints
          ? 'cmp-preposition-rt-points-total-price'
          : 'cmp-preposition-rt-miles-total-price'
      );
      settings = {
        ...settings,
        data: {
          ...settings.data,
          returnDate: ingloriousMomentNeverUseMe(state.returnDate).format('YYYY-MM-DD'),
          formattedReturnDate
        }
      };
    }
    if (combinable) {
      settings = {
        ...getCombinableDetailsPrice(
          settings,
          isRedemptionUnitMilesOrPoints,
          isRedemptionUnitPoints
        )
      };
    }
    return settings;
  };

  const restState = (currentMonth) => {
    dispatch({ type: 'SET_INITIAL_STATE', payload: currentMonth });
  };

  return {
    state,
    dispatch,
    handlerDayClick,
    handlerDayHover,
    handlerMonthNavigation,
    handlerDataChange,
    getSettingsFareItemMediumSize,
    restState
  };
}

export { useFlightCalendar, getIsDisregarded, ONE_WAY, DEPARTURE_DATE, RETURN_DATE };
